import { apiClient } from ".";

interface IAddFeddbackRequest {
  logId: number;
  feedback: string;
  feedbackType: string;
  qaId: string;
}

interface IAddFeddbackResponseData {
  Id: number;
  PatientId: number;
  Question: string;
  Answer: string;
  Feedback: string;
  FeedbackType: boolean;
  CreatedBy: number;
  updatedAt: string;
  createdAt: string;
}

interface IAddFeddbackResponse {
  message: string;
  data: { message: string };
}

const addFeedback = async (obj: IAddFeddbackRequest) => {
  const res = await apiClient.post<IAddFeddbackResponse>(`/feedback`, obj);
  return res;
};

const getFeedbackAnalytics = async ({
  fromDate, toDate, timezone, metros, range
}: { fromDate?: string, toDate?: string, timezone?: string, metros?: string[], range?: string }) => {
  const params = new URLSearchParams();

  if (fromDate) params.append('fromDate', fromDate);
  if (toDate) params.append('toDate', toDate);
  if (timezone) params.append('timezone', timezone);
  if (metros && metros.length > 0) {
    metros.forEach(metro => params.append('metro', metro));
  }
  if (range) params.append('range', range);

  const res = await apiClient.get(`/feedback-analytics`, { params });
  return res.data;
};


const getFeedbackAnalyticsDetailed = async ({
  fromDate, toDate, timezone, metros, range
}: { fromDate?: string, toDate?: string, timezone?: string, metros?: string[], range?: string }) => {
  const params = new URLSearchParams();

  if (fromDate) params.append('fromDate', fromDate);
  if (toDate) params.append('toDate', toDate);
  if (timezone) params.append('timezone', timezone);
  if (metros && metros.length > 0) {
    metros.forEach(metro => params.append('metro', metro));
  }
  if (range) params.append('range', range);

  const res = await apiClient.get(`/feedback-analytics/details`, { params });
  return res.data;
}

export const feedbackService = {
  addFeedback,
  getFeedbackAnalytics,
  getFeedbackAnalyticsDetailed
};
